import {create} from 'zustand';

type VelaUpsellState = {
  isOnRequest: boolean;
  isLuggage: boolean;
  hasStorage: boolean;
};

type VelaUpsellStore = VelaUpsellState & {
  setUpsell: (state: VelaUpsellState) => void;
};

export const EMPTY_VELA_UPSELL: VelaUpsellState = {
  isOnRequest: false,
  isLuggage: false,
  hasStorage: false,
};

export const useVelaUpsellStore = create<VelaUpsellStore>(set => ({
  ...EMPTY_VELA_UPSELL,
  setUpsell: state => set(state),
}));
